export default __webpack_public_path__ + "static/equilibre_icon_thumb-6cbab47fce9e572985b22ef16af0f81e.png";